export default "__VITE_ASSET__BcoY2Ufu__"